// src/components/AdminTableWrapper.js
import React from "react";

export default function AdminTableWrapper({ children }) {
  return (
    <div className="bg-white/95 shadow-xl border border-amber-50 rounded-2xl p-4 sm:p-6 lg:p-8 w-full">
      {/* Horizontal scroll only when needed (mobile) */}
      <div className="overflow-x-auto w-full">
        {/* Give content a sensible minimum width so the table doesn’t squash */}
        <div className="min-w-[640px] sm:min-w-0">{children}</div>
      </div>
    </div>
  );
}
